(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {

    // ── Scroll reveal ──────────────────────────────────────────
    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pv-in'); io.unobserve(e.target); } });
        }, { threshold: 0.08 })
      : null;
    document.querySelectorAll('.pv-reveal').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('pv-in');
    });

    // ── Clone the hidden trust-pill row into the visible slots ──
    (function () {
      var top = document.querySelector('nav.pv-trust-top');
      if (!top) return;
      var html = top.innerHTML;
      document.querySelectorAll('[data-pv-trust-clone]').forEach(function (c) { c.innerHTML = html; });
    })();

    // ── Ingredient accordion (tap to open the full breakdown) ──
    function setOpen(art, open) {
      var body = art.querySelector('.pv-sci-ing-body');
      var head = art.querySelector('.pv-sci-ing-head');
      art.classList.toggle('pv-open', open);
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) body.style.maxHeight = open ? (body.scrollHeight + 'px') : '0px';
    }
    document.querySelectorAll('.pv-sci-ing-head').forEach(function (head) {
      var art = head.closest('.pv-sci-ing');
      head.addEventListener('click', function () {
        setOpen(art, !art.classList.contains('pv-open'));
        syncExpandAll();
      });
    });
    // Recalculate the open card's height on resize (text reflows)
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        document.querySelectorAll('.pv-sci-ing.pv-open .pv-sci-ing-body').forEach(function (b) {
          b.style.maxHeight = b.scrollHeight + 'px';
        });
      }, 120);
    });

    // ── Expand all / collapse all ──────────────────────────────
    var expandBtn = document.querySelector('[data-pv-expand-all]');
    function allOpen() {
      var arts = document.querySelectorAll('.pv-sci-ing');
      return arts.length && Array.prototype.every.call(arts, function (a) { return a.classList.contains('pv-open'); });
    }
    function syncExpandAll() {
      if (!expandBtn) return;
      var open = allOpen();
      expandBtn.textContent = open ? 'Collapse all' : 'Expand all';
      expandBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (expandBtn) {
      expandBtn.addEventListener('click', function () {
        var open = !allOpen();
        document.querySelectorAll('.pv-sci-ing').forEach(function (a) { setOpen(a, open); });
        syncExpandAll();
      });
    }

    // ── FAQ accordion ──────────────────────────────────────────
    document.querySelectorAll('[data-pv-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pv-faq-item');
        var open = item.classList.toggle('pv-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('.pv-faq-icon').textContent = open ? '−' : '+';
      });
    });

    // ── Supplement facts popup (shared component) ──────────────
    var factsModal = document.getElementById('pv-facts-modal');
    if (factsModal) {
      function openFacts() {
        factsModal.classList.add('pv-open');
        document.body.style.overflow = 'hidden';
        var c = factsModal.querySelector('.pv-modal-close');
        if (c) c.focus();
      }
      function closeFacts() {
        factsModal.classList.remove('pv-open');
        document.body.style.overflow = '';
      }
      document.querySelectorAll('[data-pv-facts-open]').forEach(function (b) { b.addEventListener('click', openFacts); });
      factsModal.querySelectorAll('[data-pv-facts-close]').forEach(function (b) { b.addEventListener('click', closeFacts); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFacts(); });
    }

    // ── Stat count-up: animate the gold stat number 0 → target when it scrolls into view,
    //    keeping any prefix/suffix (e.g. "50%"). Same feel as the homepage stat. ──
    (function () {
      var els = document.querySelectorAll('.pv-sci-stat-num');
      if (!els.length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      function prep(el) {
        var m = (el.textContent || '').trim().match(/^(\D*)(\d[\d,]*(?:\.\d+)?)(.*)$/);
        if (!m) return null;
        var info = { el: el, prefix: m[1], target: parseFloat(m[2].replace(/,/g, '')), suffix: m[3], decimals: (m[2].split('.')[1] || '').length };
        if (!info.target) return null;
        el.textContent = info.prefix + (0).toFixed(info.decimals) + info.suffix;
        return info;
      }
      function run(info) {
        var t0 = null, dur = 1100;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var v = (1 - Math.pow(1 - p, 3)) * info.target;
          info.el.textContent = info.prefix + v.toFixed(info.decimals) + info.suffix;
          if (p < 1) requestAnimationFrame(step);
          else info.el.textContent = info.prefix + info.target.toFixed(info.decimals) + info.suffix;
        }
        requestAnimationFrame(step);
      }
      els.forEach(function (el) {
        var info = prep(el); if (!info) return;
        if ('IntersectionObserver' in window) {
          var sio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sio.unobserve(e.target); run(info); } }); }, { threshold: 0.5 });
          sio.observe(el);
        } else { run(info); }
      });
    })();

  });
}());
